interface CollectionPickerProps {
  listingId: string
  size?: 'sm' | 'md'
  knownSuggestions?: string[]
}

const DEFAULT_SUGGESTIONS = [
  'Top picks',
  'Backups',
  'Long shots',
  'Visited',
  'Rejected',
]

export type { CollectionPickerProps }
export { DEFAULT_SUGGESTIONS }
